/**
 * profanityWords.js
 *
 * profanityFilter.js'in kullandığı kelime listeleri.
 * Tüm kelimeler küçük harf ve ASCII'ye indirgenmiş yazılır (ş->s, ç->c, ğ->g, ö->o, ü->u, ı->i).
 * Rakam/sembol yazımı (p0rn0, s1kt1r) filtre tarafından otomatik çözülür, buraya yazmana gerek yok.
 *
 * Eşleşme türleri:
 *   substr  : kelimenin içinde herhangi bir yerde geçerse yakalanır      (uzun, belirgin kökler)
 *   prefix  : kelime bu kökle başlıyorsa yakalanır                         (sonuna her şey gelebilir)
 *   stem    : kök + Türkçe ek (-lar, -lik, -tan, -ı, -e ...) yakalanır     (başka devam yakalanmaz)
 *   exact   : yalnızca tam kelime (+ isteğe bağlı -s/-es) yakalanır        (kısa/riskli kelimeler)
 *   phrases : yan yana gelen kelime dizileri                               ('*' ile biten eleman önek sayılır)
 *
 * Harf kuralı: kelimede TEK harf yazarsan tekrarlı yazım da yakalanır (yarak -> yarrak, yarraak),
 * ÇİFT harf yazarsan en az iki harf şart olur (ass -> "as" yakalanmaz).
 *
 * CORE: açık küfür, cinsel içerik, ırkçı/nefret söylemi. Her zaman aktif.
 * MILD: hafif hakaret ve yumuşak cinsel kelimeler (sex, stupid, salak...). includeMild:false ile kapatılır.
 */

export const CORE = {
  substr: [
    // --- Türkçe ---
    'siktir', 'sktir', 'siktr', 'orospu', 'orspu', 'orosbu', 'pezevenk', 'ananisik', 'ananinamini',
    'aminakoy', 'aminakod', 'kodugumun', 'koyim', 'sikimsonik',
    // --- İngilizce: küfür / hakaret ---
    'fuck', 'shit', 'asshole', 'arsehole', 'asswipe', 'asshat', 'asslick', 'assclown', 'dumbass',
    'jackass', 'dickhead', 'cocksuck', 'motherfuck', 'pissoff',
    // --- İngilizce: cinsel ---
    'blowjob', 'handjob', 'rimjob', 'bukkake', 'gangbang', 'cumshot', 'cumslut', 'buttplug',
    'butthole', 'nutsack', 'ballsack', 'jackoff', 'jerkoff',
    // --- ırkçı / nefret ---
    'sandnigger', 'wetback', 'towelhead', 'raghead', 'cameljockey', 'zipperhead', 'slanteye',
    'chingchong', 'porchmonkey', 'jigaboo', 'nignog', 'heilhitler', 'siegheil',
    // --- kendine zarar kışkırtma ---
    'killyourself', 'killurself',
  ],

  prefix: [
    // --- Türkçe: cinsel / küfür ---
    'amcik', 'amcig', 'amcuk', 'amck', 'yarak', 'yarram', 'dalyarak', 'tasak', 'kaltak', 'kahpe',
    'serefsiz', 'surtuk', 'yavsak', 'namussuz', 'alcak', 'haysiyetsiz', 'gerizekali', 'dangalak',
    'gotveren', 'gotlek', 'gotun', 'gotum', 'sikim', 'sikerim', 'sikeyim', 'sikecem', 'sikicem',
    'siktimin', 'sicmak', 'sictim', 'piclik', 'fahise', 'kerhane', 'kavat', 'ensest', 'pedofil',
    'tecavuz', 'mastur', 'orgazm', 'otuzbir',
    // --- İngilizce ---
    'bitch', 'whore', 'slut', 'pusy', 'faggot', 'bastard', 'bollocks', 'douche', 'wank', 'porn',
    'hentai', 'dildo', 'orgasm', 'jizz', 'incest', 'pedophil', 'paedophil', 'molest', 'nigger',
    'sexting',
  ],

  stem: [
    // Türkçe kök + ek
    'bok', 'pust', 'ibne', 'gavat', 'sakso', 'cuk', 'pipi', 'lavuk', 'pezo', 'zenci',
  ],

  exact: [
    // --- Türkçe ---
    'amk', 'amq', 'aq', 'pedo',
    // --- İngilizce: küfür / cinsel ---
    'ass', 'arse', 'dick', 'cock', 'cunt', 'cunty', 'twat', 'fag', 'prick', 'piss', 'pissed',
    'fck', 'fuk', 'stfu', 'gtfo', 'mofo', 'shite', 'harlot', 'skank', 'thot',
    'cum', 'cumming', 'tit', 'titty', 'titties', 'boob', 'boobies', 'clit', 'clitoris', 'anus',
    'anal', 'horny', 'boner', 'milf', 'bdsm', 'xxx', 'xnxx', 'xvideos', 'rape', 'rapist', 'paedo',
    // --- ırkçı / nefret / ableist ---
    'niga', 'niggah', 'niggaz', 'nigguh', 'nibba', 'nibber', 'coon', 'darkie', 'gook', 'kike',
    'spic', 'spick', 'spik', 'beaner', 'paki', 'dago', 'redskin', 'injun', 'squaw',
    'tranny', 'shemale', 'lesbo', 'lezbo', 'retard', 'retarded', 'spaz', 'mongoloid', 'mong',
    // --- kendine zarar kışkırtma ---
    'kys',
  ],

  phrases: [
    // İngilizce
    ['kill', 'yourself'], ['kill', 'your', 'self'], ['kill', 'urself'], ['hang', 'yourself'],
    ['go', 'die'], ['white', 'power'], ['heil', 'hitler'], ['sieg', 'heil'],
    // Türkçe
    ['amina', 'koyayim'], ['amina', 'koyarim'], ['amina', 'koydugum'], ['amina', 'koyim'],
    ['anani', 'sik*'], ['bacini', 'sik*'], ['it', 'oglu', 'it'], ['geri', 'zekali'],
    ['kendini', 'as'], ['kendini', 'oldur*'],
  ],
};

export const MILD = {
  substr: [],
  prefix: ['asagilik', 'scumbag'],
  stem: [
    // Türkçe hafif hakaret / dini-etnik aşağılama
    'salak', 'aptal', 'ahmak', 'gerzek', 'embesil', 'budala', 'mankafa', 'pislik', 'dallama',
    'andaval', 'enayi', 'gavur', 'kafir', 'cingene',
    // Türkçe yumuşak cinsel
    'seks', 'seksi', 'ciplak', 'vajina',
  ],
  exact: [
    // İngilizce yumuşak cinsel
    'sex', 'sexy', 'sexi', 'nude', 'nudes', 'naked', 'penis', 'vagina', 'sperm', 'erotic', 'erotik',
    'fetish', 'threesome', 'orgy', 'onlyfans', 'hooker', 'pimp', 'hoe',
    // İngilizce hafif hakaret
    'idiot', 'moron', 'imbecile', 'stupid', 'dumb', 'loser', 'crap', 'damn', 'goddamn', 'bugger',
    'tosser', 'bellend', 'turd', 'omfg', 'incel',
    // Bağlama göre hakaret/nefret olabilen kelimeler
    'dyke', 'chink', 'jap', 'wop', 'kraut', 'honky', 'honkey', 'negro', 'nazi', 'heil',
  ],
  phrases: [],
};

/**
 * Orijinal yazımdaki harfe bakan kurallar (Türkçe ı/i, ö/o, ç/c ayrımı).
 *  needs : orijinal kelimede bu harflerden biri OLMALI
 *  not   : orijinal kelimede bu harf OLMAMALI
 * Örn. "göt" yakalanır ama İngilizce "got" yakalanmaz; "sik" yakalanır ama "sık" yakalanmaz.
 */
export const DIACRITIC = [
  { kind: 'stem', words: ['got'], needs: /[öÖ]/ },
  { kind: 'stem', words: ['pic'], needs: /[çÇ]/ },
  { kind: 'exact', words: ['oc'], needs: /[çÇ]/ },
  { kind: 'stem', words: ['amina'], needs: /ı/ },
  { kind: 'exact', words: ['sik', 'sikler', 'siklerin'], not: /[ıI]/ },
];

/**
 * Parçalı yazım ("si ktir", "fu ck", "s ik") tespiti ayarları.
 * Birleşince yalnızca TAM bir yasaklı kelime oluşuyorsa yakalanır.
 *
 * SPLIT_EXTRA : exact listesinde olduğu halde bölünmüş halde de aranacak kısa kelimeler.
 * NO_SPLIT    : masum iki kelimenin birleşiminden çıkabildiği için bölünmüş halde ARANMAYACAK kelimeler
 *               ("otuz bir", "bu dala", "wet back", "got um" ...).
 * Not: ass, cum, tit, anus, anal, penis gibi kısa kelimeler bilerek SPLIT_EXTRA'da yok;
 *      "an US" -> anus, "pen is" -> penis, "an Al" -> anal gibi yanlış pozitifler üretirdi.
 */
export const SPLIT_EXTRA = ['dick', 'cock', 'cunt', 'twat', 'porno'];
export const NO_SPLIT = [
  'wetback', 'otuzbir', 'gotun', 'gotum', 'budala', 'kaltak', 'alcak', 'tasak', 'sikim',
];
